<template>
    <el-dialog title="Historial de notificaciones"
        :visible="showDialog"
        @open="loadHistory"
        @close="close"
    >
        <div class="row">
            <div class="col-12" v-loading="loadingHistory">
                <template v-if="history.length">
                    <div class="table-responsive">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>Notificación</th>
                                    <th>Origen</th>
                                    <th class="text-center">Fecha</th>
                                    <th class="text-center">Detalle</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in history">
                                    <td>
                                        <span>{{ item.title }}</span>
                                        <br>
                                        <el-button v-if="!item.disabled_by_system"
                                            type="warning"
                                            size="mini"
                                            @click.prevent="disable(item)"
                                        >
                                            Inhabilitar
                                        </el-button>
                                    </td>
                                    <td>{{ getNameSource(item.source) }}</td>
                                    <td class="text-center">{{ item.created_at }}</td>
                                    <td class="text-center">
                                        <el-button type="primary"
                                            size="mini"
                                            @click.prevent="openHistoryDetails(item)"
                                        >
                                            <i class="fa fa-search"></i>
                                        </el-button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </template>
                <template v-else-if="!history.length && !loadingHistory">
                    <h4 class="text-center">No se encontraron registros</h4>
                </template>
            </div>
            <div class="col-12 text-center">
                <el-pagination
                    :total="pagination.total"
                    :current-page.sync="pagination.current_page"
                    :page-size="pagination.per_page"
                    @current-change="loadHistory"
                    layout="total, prev, pager, next"
                ></el-pagination>
            </div>
        </div>

        <HistoryDetails
            :showDialogDetail.sync="showDetails"
            :dataHistory="dataHistory"
            :systemId="dataSystem ? dataSystem.id : null"
        />
    </el-dialog>
</template>

<script>
    import HistoryDetails from './HistoryDetails.vue'

    export default {
        name: 'ModalHistory',
        components: {
            HistoryDetails
        },
        props: {
            showDialog: {
                type: Boolean,
                default: false
            },
            dataSystem: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                loadingHistory: false,
                history: [],
                showDetails: false,
                dataHistory: null,
                pagination: {}
            }
        },
        computed: {
            title() {
                return "Historial de notificaciones"
            }
        },
        methods: {
            close() {
                this.$emit('update:showDialog', false)
                this.history = []
                this.pagination = {}
            },

            async loadHistory() {
                try {
                    this.loadingHistory = true
                    const { data } = await this.$http.get(`/notifications/getHistory/${this.dataSystem.id}`, {
                        params: {
                            page: this.pagination.current_page
                        }
                    })
                    if (data.success) {
                        this.history = data.data
                    } else {
                        this.$message.error(data.message)
                    }
                    this.pagination = data.meta
                } catch (error) {
                    
                } finally {
                    this.loadingHistory = false
                }
            },

            openHistoryDetails(item) {
                this.showDetails = true
                this.dataHistory = item
            },

            disable(item) {
                try {
                    this.$confirm('¿Está seguro de inhabilitar esta notificación?', 'Advertencia', {
                        confirmButtonText: 'Sí, inhabilitar',
                        cancelButtonText: 'Cancelar',
                        type: 'warning'
                    }).then(async () => {
                        const { data } = await this.$http.post(`/notifications/disable`, {
                            client: this.dataSystem.id,
                            notification: item.id
                        })
                        if (data.success) {
                            this.$message.success(data.message)
                            await this.loadHistory()
                        } else {
                            this.$message.error(data.message)
                        }
                    }).catch(() => {
                        // Acción cancelada
                    })
                } catch (error) {
                    
                }
            },

            getNameSource(source) {
                let response = null
                switch (source) {
                    case 'payments':
                        response = 'Pagos'
                        break;
                    case 'configurations':
                        response = 'Configuración'
                        break;
                    default:
                        response = 'Notificaciones'
                        break;
                }
                return response
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/js/views/system/notifications/partials/ModalHistory.vue